import styled from "styled-components";

const Accessibility = styled.span`
	position: absolute;
	width: 1px;
	height: 1px !important;
	padding: 0;
	margin: -1px;
	border: none;
	clip: rect(0 0 0 0);
	overflow: hidden;
`;

export default Accessibility;
